export default {
  LOAD_STUDY_PLAN_CYCLE_OVERVIEW_PAGE_START: 'LoadStudyPlanCycleOverviewPageStart',
  LOAD_STUDY_PLAN_CYCLE_OVERVIEW_PAGE_END: 'LoadStudyPlanCycleOverviewPageEnd',
  SELECT_STUDY_PLAN_CYCLE_OVERVIEW_PAGE_TAB: 'SelectStudyPlanCycleOverviewPageTab'
};